import { hot } from 'react-hot-loader'
import React from 'react'
import DataPrivacy from '../components/DataPrivacy/DataPrivacy'

function App() {
  return (
    <>
      <DataPrivacy />
    </>
  )
}

export default hot(module)(App)
